import type { DataTableColumn, DataTableRenderCellParams } from '@/components/custom/erp/data-table-v2';
import { formatDate, formatMoney, formatNumber, formatRoundedNumber } from '@/lib/formatUtils';

export const getDataTableColumns = (handleOpenViewForm: (row: MuaHangRecord) => void): DataTableColumn[] => [
  {
    field: 'status',
    headerName: 'Trạng thái',
    width: 120,
    renderCell: (params: DataTableRenderCellParams) => {
      switch (params.row.status) {
        case '0':
          return 'Chưa ghi sổ';
        case '3':
          return 'Chờ duyệt';
        case '5':
          return 'Đã ghi sổ';
        case '9':
          return 'Hủy';
      }
    }
  },
  {
    field: 'so_ct',
    headerName: 'Số c/từ',
    width: 150,
    renderCell: params => (
      <div
        className='cursor-pointer hover:text-main hover:underline'
        onClick={e => {
          e.stopPropagation();
          handleOpenViewForm(params.row);
        }}
      >
        {params.row.so_ct}
      </div>
    )
  },
  {
    field: 'ngay_ct',
    headerName: 'Ngày c/từ',
    width: 120,
    renderCell: (params: DataTableRenderCellParams) => formatDate(params.row.ngay_ct)
  },
  {
    field: 'ma_kh',
    headerName: 'Mã khách hàng',
    width: 150,
    renderCell: (params: DataTableRenderCellParams) => {
      return params.row.ma_kh_data?.customer_code;
    }
  },
  {
    field: 'ten_kh',
    headerName: 'Tên khách hàng',
    width: 200,
    renderCell: (params: DataTableRenderCellParams) => {
      return params.row.ma_kh_data?.customer_name;
    }
  },
  { field: 'dien_giai', headerName: 'Diễn giải', width: 200 },
  {
    field: 'tk',
    headerName: 'Tk nợ',
    width: 120,
    renderCell: (params: DataTableRenderCellParams) => {
      return params.row.tk_data?.code;
    }
  },
  {
    field: 't_tt_nt',
    headerName: 'Thanh toán',
    width: 120,
    type: 'number',
    renderCell: params => formatRoundedNumber(params.row.t_tt_nt)
  },
  {
    field: 'ma_nt',
    headerName: 'Ngoại tệ',
    width: 100,
    renderCell: (params: DataTableRenderCellParams) => {
      return params.row.ma_nt_data?.ma_nt;
    }
  },
  {
    field: 'ma_ngv',
    headerName: 'Loại hóa đơn',
    width: 150,
    renderCell: (params: DataTableRenderCellParams) => {
      return params.row.ma_ngv == '1' ? '1. Giảm giá' : '2. Tăng giá';
    }
  }
];

export const getDetailDataTableColumns: DataTableColumn[] = [
  {
    field: 'ma_vt',
    headerName: 'Mã sản phẩm',
    width: 120,
    renderCell: (params: DataTableRenderCellParams) => {
      return params.row.ma_vt_data?.ma_vt;
    }
  },
  {
    field: 'ten_vt',
    headerName: 'Tên sản phẩm',
    width: 200,
    renderCell: (params: DataTableRenderCellParams) => {
      return params.row.ma_vt_data?.ten_vt;
    }
  },
  {
    field: 'dvt',
    headerName: 'Đvt',
    width: 80,
    renderCell: (params: DataTableRenderCellParams) => {
      return params.row.ma_vt_data?.dvt_data?.dvt;
    }
  },
  {
    field: 'ma_kho',
    headerName: 'Mã kho',
    width: 120,
    renderCell: (params: DataTableRenderCellParams) => {
      return params.row.ma_kho_data?.ma_kho;
    }
  },
  {
    field: 'so_luong',
    headerName: 'Số lượng',
    width: 100,
    type: 'number',
    renderCell: params => formatNumber(params.row.so_luong)
  },
  {
    field: 'gia_nt',
    headerName: 'Giá VND',
    width: 130,
    type: 'number',
    renderCell: params => formatMoney(params.row.gia_nt)
  },
  {
    field: 'tien_nt',
    headerName: 'Tiền VND',
    width: 180,
    type: 'number',
    renderCell: params => formatMoney(params.row.tien_nt)
  },
  {
    field: 'tk_vt',
    headerName: 'Tk vật tự',
    width: 100,
    renderCell: (params: DataTableRenderCellParams) => {
      return params.row.tk_vt_data?.code;
    }
  },
  { field: 'ma_thue', headerName: 'Thuế suất', width: 100 },
  {
    field: 'ma_bp',
    headerName: 'Bộ phận',
    width: 120,
    renderCell: (params: DataTableRenderCellParams) => {
      return params.row.ma_bp_data?.ma_bp;
    }
  },
  {
    field: 'ma_vv',
    headerName: 'Vụ việc',
    width: 120,
    renderCell: (params: DataTableRenderCellParams) => {
      return params.row.ma_vv_data?.ma_vu_viec;
    }
  },
  {
    field: 'ma_hd',
    headerName: 'Hợp đồng',
    width: 120,
    renderCell: (params: DataTableRenderCellParams) => {
      return params.row.ma_hd_data?.ma_hd;
    }
  },
  {
    field: 'ma_dtt',
    headerName: 'Đợt thanh toán',
    width: 120,
    renderCell: (params: DataTableRenderCellParams) => {
      return params.row.ma_dtt_data?.ma_dtt;
    }
  },
  {
    field: 'ma_ku',
    headerName: 'Khế ước',
    width: 120,
    renderCell: params => params.row.ma_ku_data?.ma_ku
  },
  {
    field: 'ma_phi',
    headerName: 'Phí',
    width: 120,
    renderCell: params => params.row.ma_phi_data?.ma_phi
  },
  {
    field: 'ma_sp',
    headerName: 'Sản phẩm',
    width: 120,
    renderCell: params => params.row.ma_sp_data?.ma_vt
  },
  {
    field: 'ma_lsx',
    headerName: 'Lệnh sản xuất',
    width: 120,
    renderCell: params => params.row.ma_lsx_data?.ma_lsx
  },
  {
    field: 'ma_cp0',
    headerName: 'C/p không h/lệ',
    width: 150,
    renderCell: params => params.row.ma_cp0_data?.ma_cpkhl
  }
];

export const historyColumns: DataTableColumn[] = [
  { field: 'username', headerName: 'Tài khoản', width: 100 },
  { field: 'nickname', headerName: 'Tên tài khoản', width: 200 },
  { field: 'action', headerName: 'Hành động', width: 100 },
  { field: 'datetime0', headerName: 'Thời gian', width: 150 }
];
